<div class="checkbox weaveCheckbox weaveTrueFalse">
  <mat-checkbox
    [id]="id"
    [checked]="data"
    (change)="changeValue($event)"
    [ngModel]="item.isChecked"
    [disabled]="disabledFlag"
  >
    {{label}}
  </mat-checkbox>
</div>
